import classNames from 'classnames';
import React, { memo } from 'react';
import { CircledCustomIcon } from 'components/Icons';
import { Text } from 'components/Typography';
import { SVGBasicType } from 'types/global';
import style from './EmptyListSmallArea.scss';

type Props = {
  icon: React.FC<SVGBasicType>;
  containerStyle?: string;
  text: string;
};

export const EmptyListSmallArea: React.FC<Props> = memo(({ icon, containerStyle, text }) => {
  return (
    <div className={classNames(style.container, containerStyle)}>
      <CircledCustomIcon containerStyle={style.iconCircle} width={24} height={24} icon={icon} />
      <Text variant="sm" weight={500} className={style.text}>
        {text}
      </Text>
    </div>
  );
});
